import { GarnerGeocodesClientV1 } from '@garner-health/api-client/svc-geocode/geocodes/geocodes-v1';

import createLogger from '~/logging';
import { Position } from '~/util';

import { baseClientOptions, getDefaultHeaders } from './common';

const log = createLogger(__filename);

// exported for testing
export type LocationResult = {
  formattedAddress: string;
  locationType: 'place' | 'fullAddress';
  position: Position;
};

class GeocodeClient {
  private readonly client: GarnerGeocodesClientV1;

  constructor() {
    this.client = new GarnerGeocodesClientV1(baseClientOptions);
  }

  async geocodeLocation(query: string): Promise<LocationResult[]> {
    return this.client
      .get('/geocode', {
        headers: await getDefaultHeaders(),
        query: { query },
      })
      .onStatus(200, r => r.json.items)
      .catch(err => {
        log.error({ err, strQuery: query }, 'Error geocoding location');
        throw Error('Error geocoding location');
      });
  }
}

export const geocodeClient = new GeocodeClient();
